import { defineAction } from '~/prix'
import fetchQuestionnaireAction from './questionnaireFetch.action.json' with { type: 'json' }
import { z } from 'zod'
import { questionnaireObject } from '../questionnaireObject'
import { dateOrIsoString } from '~/prix/types/date'

const fetchQuestionnaireDefinition = defineAction({
  ...fetchQuestionnaireAction,
  input: z.object({
    id: z.coerce.number().describe('ID do questionário'),
    cns: z.string().describe('CNS do cidadão').optional(),
    cpf: z.string().describe('CPF do cidadão').optional(),
    onlyActive: z.boolean().describe('Apenas ativos').optional(),
  }),
  output: questionnaireObject.extend({
    createdAt: dateOrIsoString().describe('Data de criação do questionário'),
    updatedAt: dateOrIsoString().describe('Data de atualização do questionário'),
  }),
})

export default fetchQuestionnaireDefinition
